"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utilities_1 = require("../../../../../utilities/utilities");
var utils_1 = require("../../utils");
var InstagramWrapper_1 = tslib_1.__importDefault(require("./InstagramWrapper"));
var Wrapper = styled_components_1["default"](InstagramWrapper_1["default"])(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  iframe.instagram-media {\n    max-width: 100%;\n    width: ", ";\n    min-width: auto !important;\n  }\n\n  .instagram-media {\n    margin: 0 auto !important;\n  }\n"], ["\n  iframe.instagram-media {\n    max-width: 100%;\n    width: ", ";\n    min-width: auto !important;\n  }\n\n  .instagram-media {\n    margin: 0 auto !important;\n  }\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return polished_1.rem(maxWidth);
});
var InstagramMedia = function (_a) {
    var _b = _a.config, data_href = _b.data_href, _c = _b.data_instgrm_captioned, data_instgrm_captioned = _c === void 0 ? true : _c, data_width = _b.data_width, config = _a.config;
    // 350 < width
    var width = utils_1.getNumberValueInRange(data_width, 550, 350);
    return (React.createElement(Wrapper, { config: config, maxWidth: width },
        React.createElement("blockquote", { className: "instagram-media", cite: data_href, "data-instgrm-captioned": data_instgrm_captioned ? '' : void 0, "data-instgrm-permalink": data_href, "data-instgrm-version": "13" },
            React.createElement("div", null,
                React.createElement("p", null,
                    React.createElement("a", { href: data_href, target: "_blank", rel: "noreferrer" }, utilities_1.__('Instagram príspevok')))))));
};
exports["default"] = InstagramMedia;
var templateObject_1;
